import ChosenMenu from "./tooltipmenu_awesome"

export default ChosenMenu;